

const triggers = [
  "EX1_006",  
  "EX1_102",
  "EX1_298",
  "EX1_557",  
  "EX1_559",  
  "EX1_562",  
  "EX1_tk33",  
  "GVG_007",  
  "GVG_028",  
  "GVG_035",  
  "GVG_065",  
  "GVG_066",  
  "GVG_088",  
  "GVG_092",  
  "GVG_094",  
  "GVG_100",  
  "GVG_111",  
  "GVG_112",  
  "BRM_019",  
  "AT_006",  
  "AT_036",  
  "AT_088",  
  "AT_110",  
  "AT_127",  
  "AT_130",  
  "OG_200",  
  "OG_229",  
  "OG_286",  
  "KAR_021",  
  "KAR_096",  
  "UNG_919",  
  "ICC_204",  
  "ICC_238",  
  "ICC_289",  
  "ICC_405",  
  "ICC_858",  
  "ICC_900",  
  "LOOT_165",  
  "LOOT_394",  
  "LOOT_414",  
  "LOOT_519",  
  "LOOT_526",  
  "GIL_817",  
  "GIL_664",  
  "GIL_692",  
  "GIL_693",  
  "GIL_826",  
  "BOT_034",  
  "BOT_103",  
  "BOT_258",  
  "BOT_280",  
  "BOT_411",  
  "BOT_433",  
  "BOT_566",  
  "BOT_914",  
  "TRL_252",  
  "TRL_257",  
  "TRL_521",  
  "TRL_531",  
  "DAL_357",  
  "DAL_553",  
  "DAL_558",  
  "ULD_133",  
  "ULD_180",  
  "ULD_240",  
  "ULD_329",  
  "DRG_036",  
  "DRG_104",  
  "YOD_038",  
  "BT_351",  
  "BT_004",  
  "BT_009",  
  "BT_121",  
  "BT_190",  
  "BT_256",  
  "BT_258",  
  "BT_305",  
  "BT_850",  
  "BT_934",  
  "SCH_120",  
  "SCH_141",  
  "SCH_142",  
  "SCH_157",  
  "SCH_224",  
  "SCH_230",  
  "SCH_231",  
  "SCH_232",  
  "SCH_234",  
  "SCH_236",  
  "SCH_241",  
  "SCH_243",  
  "SCH_248",  
  "SCH_313",  
  "SCH_607",  
  "SCH_532",  
  "SCH_614",  
  "DMF_068",  
  "YOP_018",  
  "YOP_020",
  "BAR_020",
  "BAR_021",
  "BAR_022",
  "BAR_025",
  "BAR_033",
  "BAR_043",
  "BAR_070",
  "BAR_071",
  "BAR_073",
  "BAR_078",
  "BAR_312",
  "BAR_320",
  "BAR_840",
  "BAR_843",
  "BAR_871",
  "BAR_896",
  "BAR_912",
  "CS3_019",
  "CS3_032",
  "WC_008",
  "WC_035",
  "SW_024",  
  "SW_030",  
  "SW_042",  
  "SW_045",  
  "SW_050",  
  "SW_055",  
  "SW_066",  
  "SW_307",  
  "SW_323",  
  "SW_400",  
  "SW_446",  
  "SW_061",  
  "DED_519",  
  "AV_118",  
  "AV_139",  
  "AV_143",  
  "AV_222",  
  "AV_238",  
  "ONY_003",  
  "TSC_032",  
  "TSC_647",  
  "TSC_002",  
  "TSC_007",  
  "TSC_013",  
  "TSC_083",  
  "TSC_087",  
  "TSC_218",  
  "TSC_633",  
  "TSC_642",  
  "TSC_657",  
  "TSC_753",  
  "TSC_934",  
  "TSC_942",  
  "TSC_962",  
  "TSC_962t",
  "TID_000",
  "TID_003",
  "TID_704",
  "REV_000",
  "REV_002",
  "REV_006",
  "REV_018",
  "REV_022",
  "REV_316",
  "REV_925",
  "MAW_025",
  "RLK_827",
  "RLK_677",
  "RLK_607",
  "RLK_571",
  "RLK_919"
]

export default triggers